import { apiClient, type Paginated } from '@/core/api';
import type {
  RateOverrideInput,
  Service,
  ServiceCategory,
  ServiceInput,
  ServiceRateOverride,
} from './types';

export const BASE = '/finance/services/';
const CATEGORIES = '/finance/service-categories/';
const OVERRIDES = '/finance/service-rate-overrides/';

export interface ServiceListParams {
  page?: number;
  search?: string;
  is_active?: boolean;
  category?: number;
  unit?: string;
  /** DRF `OrderingFilter` value, e.g. `name` or `-base_rate`. */
  ordering?: string;
}

export async function listServices(params: ServiceListParams = {}): Promise<Paginated<Service>> {
  const { data } = await apiClient.get<Paginated<Service>>(BASE, { params });
  return data;
}

export async function getService(id: string | number): Promise<Service> {
  const { data } = await apiClient.get<Service>(`${BASE}${id}/`);
  return data;
}

export async function createService(input: ServiceInput): Promise<Service> {
  const { data } = await apiClient.post<Service>(BASE, input);
  return data;
}

export async function updateService(
  id: string | number,
  input: Partial<ServiceInput>,
): Promise<Service> {
  const { data } = await apiClient.patch<Service>(`${BASE}${id}/`, input);
  return data;
}

export async function deleteService(id: string | number): Promise<void> {
  await apiClient.delete(`${BASE}${id}/`);
}

export async function listCategories(): Promise<Paginated<ServiceCategory>> {
  const { data } = await apiClient.get<Paginated<ServiceCategory>>(CATEGORIES);
  return data;
}

export async function createCategory(name: string): Promise<ServiceCategory> {
  const { data } = await apiClient.post<ServiceCategory>(CATEGORIES, { name });
  return data;
}

export async function getCategory(id: number): Promise<ServiceCategory> {
  const { data } = await apiClient.get<ServiceCategory>(`${CATEGORIES}${id}/`);
  return data;
}

export async function addRateOverride(input: RateOverrideInput): Promise<ServiceRateOverride> {
  const { data } = await apiClient.post<ServiceRateOverride>(OVERRIDES, input);
  return data;
}
